'use client';

import { c as _c } from "react/compiler-runtime";
import { LINK_PREFIX } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useEffect } from 'react';
import sectionStyle from '../../section.module.scss';
import styles from './ComfortMortgage.module.scss';
import { ComfortMortgageInfo } from './ComfortMortgageInfo';
const getCardImageSrc = img => {
  if (!img) {
    return '';
  }
  if (/^https?:\/\//.test(img)) {
    return encodeURI(img);
  }
  return `${LINK_PREFIX}${img}`;
};
const getPlainDescription = item => (item.description || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
const isTooltipItem = item => /^tooltip$/i.test(getPlainDescription(item));
const parseComfortMortgage = data => {
  if (!data || data.hidden) {
    return null;
  }
  const items = (data.items || []).filter(item => !item.hidden).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const title = Array.isArray(data.name) ? data.name[0] : data.name;
  let intro = '';
  const cards = [];
  items.forEach(item => {
    if (isTooltipItem(item)) {
      if (cards.length > 0) {
        cards[cards.length - 1].popup = item.title || '';
      }
      return;
    }
    const description = getPlainDescription(item);
    if (cards.length === 0 && !intro && !item.img && !description) {
      intro = item.title || '';
      return;
    }
    cards.push({
      id: item.id,
      title: item.title || '',
      description: item.description || '',
      img: getCardImageSrc(item.img),
      popup: ''
    });
  });
  if (!title && !intro && cards.length === 0) {
    return null;
  }
  return {
    title: title || '',
    intro,
    cards
  };
};
const chunkCards = (cards, size) => {
  const rows = [];
  for (let i = 0; i < cards.length; i += size) {
    rows.push(cards.slice(i, i + size));
  }
  return rows;
};
export const ComfortMortgage = t0 => {
  const $ = _c(5);
  const {
    data,
    isMobile
  } = t0;
  const parsed = parseComfortMortgage(data);
  let t1;
  let t2;
  if ($[0] !== data) {
    t1 = () => {
      console.log("[comfortable_mortgage]", data);
    };
    t2 = [data];
    $[0] = data;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!parsed) {
    return null;
  }
  let t3;
  if ($[3] !== isMobile) {
    t3 = isMobile && <div className={sectionStyle.section_line} />;
    $[3] = isMobile;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return <>{t3}<section className={styles.root}><div className={styles.header}><SafeHtmlRenderer tag="p" content={parsed.title} className={styles.title} />{parsed.intro && <SafeHtmlRenderer tag="div" content={parsed.intro} className={styles.intro} />}</div>{parsed.cards.length > 0 && <div className={styles.rows}>{chunkCards(parsed.cards, 3).map(row => <div key={row.map(_temp).join("-")} className={styles.grid}>{row.map(card_0 => {
            const infoIcon = <ComfortMortgageInfo content={card_0.popup} isMobile={isMobile} cardId={card_0.id} />;
            return <article key={card_0.id} className={styles.card}><div className={styles.icon}>{card_0.img && <img src={card_0.img} alt="" />}</div><div className={styles.cardGrow} aria-hidden="true" /><div className={styles.content}><SafeHtmlRenderer tag="div" content={card_0.title} className={styles.cardTitle} />{(card_0.description || card_0.popup) && <div className={styles.descRow}>{card_0.description ? <div className={styles.cardDesc}><SafeHtmlRenderer tag="div" content={card_0.description} className={styles.cardDescHtml} />{infoIcon}</div> : infoIcon}</div>}</div></article>;
          })}</div>)}</div>}</section></>;
};
function _temp(card) {
  return card.id;
}